<!------
  @description 右侧导航
  @methods 无
  @param 无
  @special
------>
<template>
  <div class="rightSideBar">
      <div class="item" :class="{'item_active':activeIndex == index}" v-for='(item,index) in itemList' :key="index" @click="itemBtn(index)">
        <img class="icon" :src="item.imgUrl" alt="">
        <div class="num_box" v-if="item.label === '购物车'">{{count}}</div>
        {{item.label}}</div>
  </div>
</template>

<script>
export default {
  name: 'rightSideBar',
  data () {
    return {
      blackList: [], // 不显示右侧的路由列表
      itemList: [ // 列表
        {
          imgUrl: require('@/assets/img/punchout/punchoutCart.png'),
          routerName: 'punchoutShopCart',
          label: '购物车',
          index: 0
        },
        {
          imgUrl: require('@/assets/img/punchout/punchoutOrder.png'),
          routerName: 'punchoutOrderList',
          label: '订单',
          index: 1
        }
      ],
      count: '0', // 购物车商品数量
      activeIndex: 0 // 选中下标
    }
  },
  computed: {},
  watch: {
    $route (route) {
      let index = this.itemList.findIndex((item) => {
        return item.routerName === route.name
      })
      this.activeIndex = index !== -1 ? index : null
    }
  },
  created () {
    this.init()
    // 获取购物车商品数量
    this.getShopCartCount()
  },
  methods: {
    init () {
      let index = this.itemList.findIndex((item) => {
        return item.routerName === this.$route.name
      })
      this.activeIndex = index !== -1 ? index : null
      if (!this.bus._events['shopCartNum']) {
        this.bus.$on('shopCartNum', val => {
          this.getShopCartCount()
        })
      }
    },
    itemBtn (index) {
      if (this.activeIndex !== index) {
        this.activeIndex = index
        this.$router.push({
          name: this.itemList[this.activeIndex].routerName
        })
      }
    },
    // 获取购物车各个类型数量接口
    getShopCartCount () {
      this.$request
        .get(`/front/consumer/shoppingcart/queryShoppingCartList`)
        .then(data => {
          if (data) {
            let count = data.punchoutCount || 0
            this.count = count > 99 ? '99+' : (data.punchoutCount || 0)
          } else {
            this.count = 0
          }
        })
        .catch(() => {
          this.count = 0
        })
    }
  }
}
</script>

<style scoped lang='scss'>
.rightSideBar{
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  width: 50px;
  height: 100%;
  background: #595959;
  display: flex;
  justify-content: center;
  flex-direction: column;
  z-index: 99999;
  .item{
    position: relative;
    width: 100%;
    letter-spacing: 0;
    text-align: center;
    font-size: 12px;
    color: #ffffff;
    font-family: PingFangSC, PingFangSC-Regular;
    padding: 7px 0;
    cursor: pointer;
    .icon{
      width: 22px;
      height: 22px;
      display: block;
      margin: 0 auto 3px;
    }
    .num_box{
      position: absolute;
      right: 4px;
      top: 5px;
      padding: 3px 4px;
      background: #ffffff;
      color: #E4393C;
      border-radius: 10px;
      height: 14px;
      line-height: 7px;
      font-size: 12px;
    }
  }
  .item_active{
    background: #E4393C;
  }
}
</style>
